(function () {
	let local = "/";
	document.addEventListener("DOMContentLoaded", function (_) {
		if (Shopify?.routes) {
			const { root } = Shopify.routes;
			locale = root;
		}
	});
	document.addEventListener(
		"octane.quiz.completed",
		function () {
			window.location.replace(
				"https://uk.genseebeauty.com/apps/jurni/linen-rw-brush",
			);
		},
		false,
	);
})();
